export function filterByOption(data: any, filterOption: string) {
  switch (filterOption) {
    case 'overpayment':
      return data.balance < 0;
    case 'balance':
      return data.balance > 0;
    case 'all':
      return data.balance;
    default:
      return data.balance;
  }
}
